import { render } from "./PdfGeneration.vue?vue&type=template&id=351dd9c0&scoped=true"
import script from "./PdfGeneration.vue?vue&type=script&lang=js"
export * from "./PdfGeneration.vue?vue&type=script&lang=js"

import "./PdfGeneration.vue?vue&type=style&index=0&id=351dd9c0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351dd9c0"]])

export default __exports__